var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.3011 0H3.688C1.65344 0 0 1.61407 0 3.60513V46.3921C0 48.3833 1.65344 50 3.688 50H46.3011C48.3398 50 50 48.3832 50 46.3921V3.60513C50 1.61407 48.3398 0 46.3011 0Z",
    fill: "#007BB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4086 22.4563C7.4086 20.4064 9.0704 18.7446 11.1203 18.7446V18.7446C13.1703 18.7446 14.832 20.4064 14.832 22.4563V38.8936C14.832 40.9435 13.1703 42.6053 11.1203 42.6053V42.6053C9.0704 42.6053 7.4086 40.9435 7.4086 38.8936V22.4563ZM11.1223 6.88336C13.4946 6.88336 15.4206 8.81009 15.4206 11.1837C15.4206 13.558 13.4946 15.4846 11.1223 15.4846C8.74049 15.4846 6.81982 13.558 6.81982 11.1837C6.81994 8.81009 8.74049 6.88336 11.1223 6.88336Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4842 22.299C19.4842 20.336 21.0756 18.7446 23.0386 18.7446H24.9621C25.8628 18.7446 26.593 19.4748 26.593 20.3756V21.9431C26.593 21.9781 26.6214 22.0065 26.6564 22.0065V22.0065C26.68 22.0065 26.7014 21.9938 26.7125 21.9731C27.7123 20.1072 30.1247 18.1525 33.7112 18.1525C41.22 18.1525 42.6077 23.0931 42.6077 29.5193V38.8977C42.6077 40.9453 40.9477 42.6053 38.9 42.6053V42.6053C36.8523 42.6053 35.1924 40.9453 35.1924 38.8977V31.0019C35.1924 28.2349 35.1448 24.6751 31.3389 24.6751C27.48 24.6751 26.8912 27.6909 26.8912 30.8037V38.9018C26.8912 40.9472 25.2331 42.6053 23.1877 42.6053V42.6053C21.1423 42.6053 19.4841 40.9472 19.4841 38.9018L19.4842 22.299Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLd);
export default __webpack_public_path__ + "static/media/ld.a5371ed7efbdb12e242893aecdede83d.svg";
export { ForwardRef as ReactComponent };